// cart-wsp-dynamic.js
// 动态渲染购物车Wholesale商品的WSP价格
(function () {
  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    // 使用与 formatPriceTruncate 相同的精度处理
    const price = cents / 100;
    if (isNaN(price)) return 'N/A';
    let [intPart, decPart = ''] = String(price).split('.');
    decPart = decPart.slice(0, 2);
    let formatted = decPart.length > 0 ? `${intPart}.${decPart}` : `${intPart}.00`;
    if (decPart.length === 1) formatted += '0';
    if (decPart.length === 0) formatted = `${intPart}.00`;
    return `$${formatted}`;
  }

  // 格式化价格，保留两位小数但不四舍五入
  function formatPriceTruncate(price) {
    if (isNaN(price)) return 'N/A';
    let [intPart, decPart = ''] = String(price).split('.');
    decPart = decPart.slice(0, 2);
    let formatted = decPart.length > 0 ? `${intPart}.${decPart}` : `${intPart}.00`;
    if (decPart.length === 1) formatted += '0';
    if (decPart.length === 0) formatted = `${intPart}.00`;
    return `$${formatted}`;
  }

  // 计算并渲染WSP总价和节省金额
  function renderWspTotal() {
    let total = 0;
    let msrpTotal = 0;
    console.log('=== renderWspTotal START ===');
    document.querySelectorAll('.cart-item').forEach(function (cartItem) {
      // 选择PC端的WSP价格元素
      const wspDiv = cartItem.querySelector('.cart-item__price.wsp-price[data-tiered-price]');
      // 选择移动端的WSP价格元素
      const mobileWspDiv = cartItem.querySelector('.cart-price-mobile-container .wsp-price[data-tiered-price]');

      // 使用PC端或移动端的元素来获取数据
      const dataElement = wspDiv || mobileWspDiv;
      if (!dataElement) {
        console.log('No WSP data element found for cart item');
        return;
      }

      let tieredPrice;
      try {
        tieredPrice = JSON.parse(dataElement.getAttribute('data-tiered-price'));
      } catch (e) {
        console.error('Failed to parse tiered price:', e);
        return;
      }
      if (!tieredPrice || !Array.isArray(tieredPrice.prices)) {
        console.log('Invalid tiered price structure');
        return;
      }
      const input = cartItem.querySelector('.quantity__input');
      if (!input) {
        console.log('No quantity input found');
        return;
      }
      const qty = parseInt(input.value, 10) || 1;
      // 获取原价作为默认 WSP
      let originalPrice = 0;
      const originalPriceAttr = dataElement.getAttribute('data-original-price');
      if (originalPriceAttr) {
        originalPrice = parseFloat(originalPriceAttr / 100) || 0;
      }

      let wsp = originalPrice; // 默认使用原价
      for (const item of tieredPrice.prices) {
        const min = parseInt(item.min, 10) || 1;
        const max = item.max !== undefined && item.max !== null ? parseInt(item.max, 10) : null;
        if ((max === null && qty >= min) || (max !== null && qty >= min && qty <= max)) {
          wsp = item.price;
          break; // 找到匹配的区间后立即退出
        }
      }
      console.log(`Cart Item - Qty: ${qty}, WSP: $${wsp}, Item Total: $${wsp * qty}`);
      total += wsp * qty;
      // 取MSRP价格（同一cart-item下的msrp-price区块）
      const msrpDiv = cartItem.querySelector('.msrp-price .cart-item__final-price');
      if (msrpDiv) {
        // 解析价格文本，去除货币符号，仅保留数字
        const msrpText = msrpDiv.textContent.replace(/[^\d.]/g, '');
        const msrp = parseFloat(msrpText);
        if (!isNaN(msrp)) {
          console.log(`MSRP: $${msrp}, Item Total: $${msrp * qty}`);
          msrpTotal += msrp * qty;
        }
      }
    });
    const totalEl = document.getElementById('js-wsp-total');
    if (totalEl) {
      console.log('=== WSP Total:', total, '===');
      totalEl.textContent = formatMoney(total * 100);
    }

    // 更新 MSRP Total
    const msrpTotalEl = document.querySelector('.cart__blocks-row-value--msrp');
    if (msrpTotalEl) {
      console.log('=== MSRP Total:', msrpTotal, '===');
      msrpTotalEl.textContent = formatMoney(msrpTotal * 100);
    }

    // 新增：Estimated Total
    const estimatedTotalEl = document.getElementById('js-wsp-estimated-total');
    console.log('estimatedTotalEl', estimatedTotalEl);
    if (estimatedTotalEl) {
      console.log('=== Setting Estimated Total to:', total, '===');
      estimatedTotalEl.textContent = formatMoney(total * 100);
    }
    const saveEl = document.getElementById('js-wsp-save');
    if (saveEl) {
      const save = msrpTotal - total;
      console.log('=== You Save:', save, '===');
      saveEl.textContent = formatMoney(save * 100);
    }
    console.log('=== renderWspTotal END ===');
  }

  function updateWspPriceForCartItem(cartItem) {
    console.log('updateWspPriceForCartItem', cartItem);

    // 选择PC端的WSP价格元素
    const wspDiv = cartItem.querySelector('.cart-item__price.wsp-price[data-tiered-price]');
    console.log('wspDiv111', wspDiv);

    // 选择移动端的WSP价格元素
    const mobileWspDiv = cartItem.querySelector('.cart-price-mobile-container .wsp-price[data-tiered-price]');
    console.log('mobileWspDiv', mobileWspDiv);

    // 使用PC端或移动端的元素来获取数据
    const dataElement = wspDiv || mobileWspDiv;
    if (!dataElement) return;

    let tieredPrice;
    try {
      tieredPrice = JSON.parse(dataElement.getAttribute('data-tiered-price'));
    } catch (e) {
      return;
    }
    if (!tieredPrice || !Array.isArray(tieredPrice.prices)) return;
    const input = cartItem.querySelector('.quantity__input');
    if (!input) return;
    const qty = parseInt(input.value, 10) || 1;
    // 获取原价作为默认 WSP
    let originalPrice = 0;
    const originalPriceAttr = dataElement.getAttribute('data-original-price');
    if (originalPriceAttr) {
      originalPrice = parseFloat(originalPriceAttr / 100) || 0;
    }

    let wsp = originalPrice; // 默认使用原价
    for (const item of tieredPrice.prices) {
      const min = parseInt(item.min, 10) || 1;
      const max = item.max !== undefined && item.max !== null ? parseInt(item.max, 10) : null;
      if ((max === null && qty >= min) || (max !== null && qty >= min && qty <= max)) {
        wsp = item.price;
        break; // 找到匹配的区间后立即退出
      }
    }
    console.log('wsp', wsp);

    // 更新PC端价格
    if (wspDiv) {
      const wspPriceEl = wspDiv.querySelector('.js-wsp-price');
      console.log('wspPriceEl', wspPriceEl);
      if (wspPriceEl && wsp !== null) {
        wspPriceEl.textContent = formatPriceTruncate(wsp);
      }
    }

    // 更新移动端价格
    if (mobileWspDiv) {
      const mobileWspPriceEl = mobileWspDiv.querySelector('.js-wsp-price');
      console.log('mobileWspPriceEl', mobileWspPriceEl);
      if (mobileWspPriceEl && wsp !== null) {
        mobileWspPriceEl.textContent = formatPriceTruncate(wsp);
      }
    }

    renderWspTotal();
  }

  function initialRender() {
    console.log('=== initialRender called ===');
    document.querySelectorAll('.cart-item').forEach(function (cartItem) {
      updateWspPriceForCartItem(cartItem);
    });
    renderWspTotal();
  }

  // 事件委托，兼容动态渲染
  document.addEventListener('change', function (e) {
    if (e.target && e.target.classList.contains('quantity__input')) {
      const cartItem = e.target.closest('.cart-item');
      if (cartItem) updateWspPriceForCartItem(cartItem);
    }
  });

  // 防抖函数
  function debounce(fn, delay) {
    let timer = null;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(fn, delay);
    };
  }

  // MutationObserver监听cart-items-wrapper，优化：只监听直接子节点，渲染后断开再重连
  function observeCartItems() {
    const wrapper = document.querySelector('.cart-items-wrapper');
    if (!wrapper) return;
    let observer;
    const debouncedRender = debounce(function () {
      console.log('cart-items-wrapper changed (debounced), re-render WSP prices');
      initialRender();
      // 渲染后断开observer，200ms后再重连
      observer.disconnect();
      setTimeout(() => {
        observer.observe(wrapper, { childList: true, subtree: false });
      }, 200);
    }, 100);
    observer = new MutationObserver(function (mutationsList) {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          debouncedRender();
          break;
        }
      }
    });
    observer.observe(wrapper, { childList: true, subtree: false });
  }

  function initializeWspPrices() {
    console.log('=== initializeWspPrices called ===');
    // 首先尝试直接初始化
    const cartItems = document.querySelectorAll('.cart-item');
    console.log('Found cart items:', cartItems.length);
    let hasWspElements = false;

    cartItems.forEach(function(cartItem) {
      const wspDiv = cartItem.querySelector('.cart-item__price.wsp-price[data-tiered-price]');
      const mobileWspDiv = cartItem.querySelector('.cart-price-mobile-container .wsp-price[data-tiered-price]');
      if (wspDiv || mobileWspDiv) {
        hasWspElements = true;
      }
    });

    console.log('Has WSP elements:', hasWspElements);

    if (hasWspElements) {
      // WSP元素已存在，直接初始化
      console.log('WSP elements found, initializing...');
      initialRender();
      observeCartItems();
    } else {
      // WSP元素还不存在，监听.cart-items-wrapper的变化
      console.log('WSP elements not found, setting up MutationObserver...');
      const wrapper = document.querySelector('.cart-items-wrapper');
      console.log('Wrapper element:', wrapper);
      if (!wrapper) {
        console.log('No wrapper found, cannot set up observer');
        return;
      }

      const observer = new MutationObserver(function(mutations) {
        console.log('MutationObserver triggered');
        // 检查是否现在有WSP元素了
        const cartItems = document.querySelectorAll('.cart-item');
        let hasWspElements = false;

        cartItems.forEach(function(cartItem) {
          const wspDiv = cartItem.querySelector('.cart-item__price.wsp-price[data-tiered-price]');
          const mobileWspDiv = cartItem.querySelector('.cart-price-mobile-container .wsp-price[data-tiered-price]');
          if (wspDiv || mobileWspDiv) {
            hasWspElements = true;
          }
        });

        if (hasWspElements) {
          console.log('WSP elements detected, initializing...');
          initialRender();
          observeCartItems();
          observer.disconnect();  // 找到后立即断开，避免重复初始化
        }
      });

      observer.observe(wrapper, { childList: true, subtree: true });
      console.log('MutationObserver set up');
    }
  }

  if (document.readyState === 'loading') {
    console.log('Document still loading, waiting for DOMContentLoaded');
    document.addEventListener('DOMContentLoaded', initializeWspPrices);
  } else {
    console.log('Document already loaded, calling initializeWspPrices immediately');
    initializeWspPrices();
  }
})();
